import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

const useDatasetMappedValue = (
  mapValue: number | undefined,
  mapperId: number
): { value: string; isLoading: boolean } => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);

  if (isLoading) return { value: "", isLoading };
  if (mapValue === undefined) return { value: "-", isLoading };

  const mappedEntry = data?.mappers?.find(m => m.key === mapValue);
  return { value: String(mappedEntry?.label ?? mapValue), isLoading };
};

export default useDatasetMappedValue;
